import { Pipe, PipeTransform, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'safehtml',
})
export class SafehtmlPipe implements PipeTransform {
  private sanitizer = inject(DomSanitizer);
  private platformId = inject(PLATFORM_ID);

  transform(html: any) {
    if (typeof html !== 'string') return this.sanitizer.bypassSecurityTrustHtml(html);
    const sanitized = isPlatformBrowser(this.platformId)
      ? this.fixIframesDom(html)
      : this.fixIframesRegex(html);
    return this.sanitizer.bypassSecurityTrustHtml(sanitized);
  }

  private fixIframesDom(html: string): string {
    const tpl = document.createElement('template');
    tpl.innerHTML = html;
    // Remove external <link> and <script> tags (Bootstrap, N1ED, etc.) injected by CMS
    tpl.content.querySelectorAll('link[href], script[src]').forEach((el) => el.remove());
    tpl.content.querySelectorAll('iframe').forEach((iframe) => {
      const raw = iframe.getAttribute('allow') ?? '';
      const cleaned = raw.replace(/;\s*\bweb-share\b/gi, '').replace(/\bweb-share\b\s*;?\s*/gi, '').trim();
      iframe.setAttribute('allow', cleaned);
    });
    const wrapper = document.createElement('div');
    wrapper.appendChild(tpl.content.cloneNode(true));
    return wrapper.innerHTML;
  }

  private fixIframesRegex(html: string): string {
    return html
      .replace(/<link[^>]+href[^>]*>/gi, '')
      .replace(/<script[^>]+src[^>]*>[\s\S]*?<\/script>/gi, '')
      .replace(/;\s*\bweb-share\b/gi, '')
      .replace(/\bweb-share\b\s*;?\s*/gi, '');
  }
}
